// extracted by mini-css-extract-plugin
module.exports = {"root":"desktop-map_root__1ZnND","closeButton":"desktop-map_closeButton__3u833","mapContainer":"desktop-map_mapContainer__3VNke"};